/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type PostApiBookingTenantUpdate200ChannelSync = typeof PostApiBookingTenantUpdate200ChannelSync[keyof typeof PostApiBookingTenantUpdate200ChannelSync];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiBookingTenantUpdate200ChannelSync = {
  queued: 'queued',
  not_supported: 'not_supported',
} as const;
